import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// TODO: fix sibling import
import { catalogLayoutSlice } from 'src/features/catalog';

export const useOpenCatalogItem = () => {
  const dispatch = useDispatch();
  return useCallback(
    (id: number, _url?: string | null) => {
      dispatch(catalogLayoutSlice.actions.setActiveItem(id));
    },
    [dispatch],
  );
};
